import React from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import LocationPicker from "../location/LocationPicker";

const LocationComponent = ({ value, onChange, city, street, houseNumber }) => {
  const onLocationChanged = (val) => {
    onChange(val);
  };
  return value !== undefined ? (
    <LocationPicker
      city={city}
      street={street}
      houseNumber={houseNumber}
      activeGeo={value}
      onLocationChanged={onLocationChanged}
    />
  ) : null;
};

const LocationFormItem = (props) => {
  const { name, city, street, houseNumber } = props;

  return (
    <Form.Item name={name} style={{ marginBottom: "14px" }}>
      <LocationComponent
        city={city}
        street={street}
        houseNumber={houseNumber}
      />
    </Form.Item>
  );
};

LocationFormItem.propTypes = {
  name: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default LocationFormItem;
